import { combineReducers } from 'redux';
import { createReducer } from 'typesafe-actions';

import { fetchDisabledComponentAsync, setIsPackagePrice, setUserIdentifier } from './actions';
import { DisabledComponent } from 'Common-Types';

export const isPackagePrice = createReducer(false).handleAction(
  setIsPackagePrice,
  (_, action) => action.payload,
);

export const userIdentifier = createReducer('').handleAction(
  setUserIdentifier,
  (_, action) => action.payload,
);

export const isDisabledComponent = createReducer({} as DisabledComponent).handleAction(
  fetchDisabledComponentAsync.success,
  (_state, action) => action.payload,
);

const commonReducer = combineReducers({
  isPackagePrice,
  userIdentifier,
  isDisabledComponent,
});
export default commonReducer;
export type CommonState = ReturnType<typeof commonReducer>;
